module.exports = __webpack_public_path__ + "img/exportTXT.c29637b0.svg";